import { SchedulesTypes } from '@mode/shared/contract-common';
import { createAction, props } from '@ngrx/store';

export const loadSchedules = createAction(
  '[Dataset View Page] LOAD_DATASET_SCHEDULES',
  props<{ datasetToken: string }>()
);

export const loadSchedulessSuccess = createAction(
  '[Dataset View Page] LOAD_DATASET_SCHEDULES_SUCCESS',
  props<{ schedules: SchedulesTypes.Schedule[] }>()
);
